<template>
  <div :class="bodyClass">
    <div class="content-wrap">
      <div :class="{ 'content-collapsible': collapsible }" @click="toggleCollapsibleContent">
        <button v-if="collapsible" class="icon-button">
          <span class="material-icons" :class="{ collapsed: collapsed }">expand_more</span>
        </button>
        <header class="content-header cf" v-if="title" data-testid="form__header">
          <h3>{{ title }}</h3>
        </header>
      </div>
      <div class="content-body" :class="{ collapsed: collapsed }">
        <form class="form" @submit.prevent="$emit('submit')" :method="method">
          <slot />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Form',
  props: {
    title: { required: false, type: String },
    method: { type: String, required: false, default: 'post' },
    bodyClass: { type: String, default: 'body-content cf' },
    collapsible: { type: Boolean, default: false },
  },
  data() {
    return {
      collapsed: this.collapsible,
    }
  },
  methods: {
    toggleCollapsibleContent() {
      if (!this.collapsible) return
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<style lang="scss" scoped>
.content-collapsible {
  padding: 0 1.25rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  & .content-header {
    border-bottom: none;
  }

  & .material-icons {
    transform: rotate(180deg);
    &.collapsed {
      transform: rotate(0deg);
    }
  }
}
.content-body {
  &.collapsed {
    height: 0;
    visibility: hidden;
    overflow: hidden;
    padding: 0;
  }
}

form.form {
  display: flex;
  flex-flow: column;
}
</style>
